<template>
    <b-card no-body>
        <b-card-body>
            <b-row class="justify-content-between">
                <b-col cols="auto">
                    <h5 class="font-weight-bold">Item Availability Control</h5>
                    <p>All item availabilities are set to No Limit by default. Items with Quantity Limit are listed below.</p>
                </b-col>
                <b-col cols="auto">
                    <b-button-group class="mb-2">
                        <b-button
                            :class="modeType === 'Food' ? 'activeBtn' : 'deactiveBtn' "
                            @click="getAllAvailable('Food')"
                        >Food</b-button>
                        <b-button
                            :class="modeType === 'Drink' ? 'activeBtn' : 'deactiveBtn' "
                            @click="getAllAvailable('Drink')"
                        >Drink</b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <b-table
                    hover
                    show-empty
                    stacked="md"
                    head-variant="dark"
                    :empty-text="'No Records'"
                    :empty-filtered-text="'NoRecords'"
                    :items="items"
                    :fields="fields"
                    @row-clicked="onRowClicked"
            >
                <template v-slot:cell(QLimit)="data">
                    <div class="text-center">
                        {{data.item.Total}} ({{data.item.Total_Remain}})
                    </div>
                </template>
                <template v-slot:cell(action)="data">
                    <edit-available :ref="'editAvailable-' + data.index" :value="data.item" :itemType="modeType" @refreshGetAll="refreshGetAll"/>
                </template>

            </b-table>
        </b-card-body>
        <b-card-footer class="d-flex flex-row justify-content-between">
            <add-available @refreshGetAll="refreshGetAll"/>
        </b-card-footer>
    </b-card>
</template>

<script>
    import addAvailable from "./addAvailable";
    import editAvailable from "./editAvailable";
    export default {
        name: "index",
        components: {
            addAvailable,
            editAvailable
        },
        data () {
            return {
                modeType: 'Food',
                fields: [
                    { key: 'ItemName', label: 'Name', sortable: false, class: '' },
                    { key: 'Category', label: 'Category', sortable: false, class: '' },
                    { key: 'MenuType', label: 'Menu Type', sortable: false, class: '' },
                    { key: 'QLimit', label: 'Quantity Limit (Remaining Count)', thClass: 'text-center', tdClass: 'text-center', sortable: false, class: '' },
                    { key: 'ResetAction', label: 'End of Day Reset', sortable: false, class: '' },
                    { key: 'action', label: '', sortable: false, class: '' },
                ],
                items: [

                ],
            }
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal) {
                        this.getAll(newVal)
                    }
                },
                immediate: true
            }
        },
        methods: {
            getAll (RestaurantID) {
                const model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID,
                    ItemType: this.modeType,
                    ItemID: -1
                }
                this.$api.getRestaurant.GetRestaurantItemAvailability(model).then(res => {
                    if (res.success) {
                        this.items = res.results
                    }
                }).catch(() => {})
            },
            getAllAvailable (modeType) {
                this.modeType = modeType
                this.getAll(this.$store.state.selectedRestaurantId)
            },
            refreshGetAll (RestaurantID) {
                this.getAll(RestaurantID)
            },
            onRowClicked (item, index) {
                const editRef = this.$refs['editAvailable-' + index]
                if (editRef) {
                    editRef.getItem()
                }
            }
        }
    }
</script>

<style scoped>
    .goMenuHeaderBtn{
        background: #6f7882 !important;
        color: #fff !important;
    }
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
    ::v-deep tbody tr {
        cursor: pointer;
    }
</style>
